import Grid from '@mui/material/Grid'
import { useContext, useEffect } from 'react'
import { InformesContext } from '../providers/InformesProvider'
import FilterListOfValues from './FilterListOfValues'
import FiltersCustomTextField, { FiltersValuePosition } from './FiltersCustomTextField'

/**
 *
 * @component
 *
 * @param {object} props
 * @param {InformeFilter} props.filter
 * @param {boolean} props.validating
 * @param {function} props.setFiltersValues
 * @param {object} props.filtersValues
 * @param {boolean} props.disabled
 * @returns {JSX.Element}
 */
const FilterTextField = ({ filter, validating, disabled }) => {
  const Context = useContext(InformesContext)

  function changeFilter(newValue, pos) {
    const newFilter = { ...Context.active.filterData }
    newFilter[pos] = newValue
    Context.active.setFilterData(newFilter)
  }

  useEffect(() => {
    const newFilter = { ...Context.active.filterData }
    if (filter.tipo_filtro === 'I') {
      newFilter[`${filter.nombre_filtro}${FiltersValuePosition.DESDE}`] =
        filter.valor_inicial_filtro_desde
      newFilter[`${filter.nombre_filtro}${FiltersValuePosition.HASTA}`] =
        filter.valor_inicial_filtro_hasta
    } else newFilter[`${filter.nombre_filtro}`] = filter.valor_inicial_filtro

    Context.active.setFilterData(newFilter)
  }, [filter])

  return (
    <Grid container spacing={2}>
      {filter.tipo_filtro !== 'I' ? (
        <Grid size={{ xs: 6 }}>
          {filter.lista_valores ? (
            <FilterListOfValues
              filter={filter}
              validating={validating}
              position={FiltersValuePosition.FIJO}
              changeFilter={changeFilter}
              disabled={disabled}
            />
          ) : (
            <FiltersCustomTextField
              filter={filter}
              validating={validating}
              position={FiltersValuePosition.FIJO}
              changeFilter={changeFilter}
              disabled={disabled}
            />
          )}
        </Grid>
      ) : (
        <>
          <Grid size={{ xs: 6 }}>
            {filter.lista_valores ? (
              <FilterListOfValues
                filter={filter}
                validating={validating}
                position={FiltersValuePosition.DESDE}
                changeFilter={changeFilter}
                disabled={disabled}
              />
            ) : (
              <FiltersCustomTextField
                filter={filter}
                validating={validating}
                position={FiltersValuePosition.DESDE}
                changeFilter={changeFilter}
                disabled={disabled}
              />
            )}
          </Grid>
          <Grid size={{ xs: 6 }}>
            {filter.lista_valores ? (
              <FilterListOfValues
                filter={filter}
                validating={validating}
                position={FiltersValuePosition.HASTA}
                changeFilter={changeFilter}
                disabled={disabled}
              />
            ) : (
              <FiltersCustomTextField
                filter={filter}
                validating={validating}
                position={FiltersValuePosition.HASTA}
                changeFilter={changeFilter}
                disabled={disabled}
              />
            )}
          </Grid>
        </>
      )}
    </Grid>
  )
}

export default FilterTextField
